<template>
    <v-layout>
        <v-flex>
            <div>
                <v-card>
                    <!-- <v-toolbar flat> -->
                    <!-- <v-row> -->
                    <v-btn id="top-buttons" text small @click="prev">
                        <v-icon small> ti-angle-left </v-icon>
                    </v-btn>
                    <v-btn id="top-buttons" small color="grey" @click="setToday"> Heute </v-btn>
                    <v-btn id="top-buttons" text small @click="next">
                        <v-icon small> ti-angle-right </v-icon>
                    </v-btn>
                    {{ calendarHeadline }} - Kalender wird alle 60 Sek. aktualisiert
                    <!-- <v-toolbar-title> </v-toolbar-title> -->
                    <!-- <v-spacer></v-spacer> -->
                    <v-btn small id="top-buttons" color="grey" @click="changeView(selectedView)">
                        <span>{{ selectedView }}</span>
                    </v-btn>
                    <v-btn id="top-buttons" :right="true" :absolute="true" small color="grey" to="addblocker">Blocker setzen </v-btn>
                    <!-- </v-row> -->
                    <!-- </v-toolbar> -->
                </v-card>
                <v-sheet height="1000">
                    <v-calendar
                        ref="calendar"
                        v-model="start"
                        color="primary"
                        :type="calendarType"
                        locale="de"
                        :short-weekdays="false"
                        :max-days="maxDays"
                        :weekdays="weekdays"
                        :interval-format="intervalFormat"
                        :first-interval="27"
                        :interval-count="64"
                        :interval-height="15"
                        :interval-minutes="15"
                        @click:date="changeToWeekView">
                        <!-- the events at the bottom (timed) -->
                        <template v-slot:dayBody="{ date, timeToY, minutesToPixels }">
                            <template v-for="(event, index) in eventsMap[date]">
                                <!-- timed events -->
                                <div
                                    :key="index"
                                    @click="showEvent($event, event)"
                                    :style="{
                                        top: timeToY(event.time) + 'px',
                                        height: minutesToPixels(event.duration) + 'px',
                                        'background-color': event.kundennr !== 1 ? event.color : '#000000',
                                        color: event.kundennr == 1 ? 'white' : checkIfEntryIsPast(date) ? '#9e9e9e' : 'black'
                                    }"
                                    class="my-event with-time"
                                    v-html="event.kundennr == 1 ?event.title  : event.duration >= 25?  `${event.title} | ${event.details}<br><small>${event.strasse} ${event.hausnr}</small>`: `${event.title} | ${event.details}, ${event.strasse} ${event.hausnr}` "></div>
                            </template>
                        </template>
                    </v-calendar>
                    <v-menu
                        v-if="selectedEvent.kundennr !== 1"
                        v-model="selectedOpen"
                        :close-on-content-click="false"
                        :position-x="x - 500"
                        :position-y="y - 250"
                        absolute
                        :activator="selectedElement">
                        <v-card color="grey lighten-4" min-width="350px" flat>
                            <v-toolbar :color="selectedEvent.color" dark>
                                <v-toolbar-title v-html="`${selectedEvent.title} (Kndnr: ${selectedEvent.kundennr})`"></v-toolbar-title>
                            </v-toolbar>
                            <v-card-title primary-title style="font-size: 16px">
                                <span
                                    v-html="
                                        `
                    ${selectedEvent.anfang ? selectedEvent.anfang.slice(0, 5) : ''} Uhr - ${selectedEvent.ende ? selectedEvent.ende.slice(0, 5) : ''} Uhr<br>
                    Ort:  ${selectedEvent.strasse}  ${selectedEvent.hausnr},  ${selectedEvent.plz}  ${selectedEvent.stadt} <br>
                    Bezirk: ${selectedEvent.bezirk}<br>
                  `
                                    "></span>
                            </v-card-title>
                        </v-card>
                    </v-menu>
                </v-sheet>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    data: () => ({
        selectedEvent: {},
        selectedElement: null,
        x: 0,
        y: 0,
        selectedOpen: false,
        timer: "",
        start: "",
        selectedView: "Woche",
        weekdays: [1, 2, 3, 4, 5, 6],
        maxDays: 6,
        events: [],
        calendarType: "week",
        calendarHeadline: "",
        auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH)
    }),
    computed: {
        // convert the list of events into a map of lists keyed by date
        eventsMap() {
            const map = {}
            this.events.forEach((e) => (map[e.date] = map[e.date] || []).push(e))
            return map
        }
    },
    created() {
        this.setToday()
        this.fetchTermine()
        this.timer = setInterval(this.fetchTermine, 60000)
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods: {
        checkIfEntryIsPast(date) {
            var today = new Date()
            var dd = String(today.getDate()).padStart(2, "0")
            var mm = String(today.getMonth() + 1).padStart(2, "0") //January is 0!
            var yyyy = today.getFullYear()

            var todaydate = Date.parse(yyyy + "-" + mm + "-" + dd)
            var eventdate = Date.parse(date)
            // console.log(todaydate)
            // console.log(date)
            if (eventdate < todaydate) {
                return true
            } else {
                return false
            }
        },
        changeCalendarHeadline() {
            var date = new Date(this.start)
            this.calendarHeadline = date.toLocaleString("de", { month: "long" }) + " " + date.getFullYear()
        },
        changeToWeekView() {
            this.selectedView = "Woche"
            this.calendarType = "week"
            this.weekdays = [1, 2, 3, 4, 5, 6]
            this.maxDays = 6
        },
        changeView(view) {
            if (view === "Woche") {
                this.selectedView = "Monat"
                this.calendarType = "month"
                this.weekdays = [0, 1, 2, 3, 4, 5, 6]
                this.maxDays = 7
            } else {
                this.selectedView = "Woche"
                this.calendarType = "week"
                this.weekdays = [1, 2, 3, 4, 5, 6]
                this.maxDays = 6
            }
        },
        fetchTermine() {
            this.$http.get(process.env.VUE_APP_NODE_API_URL + "/heimspiel/kalender/termine", { headers: { Authorization: this.auth } }).then(function(response) {
                console.log(response)
                this.events = response.body.data.map((termin) => {
                    return {
                        title:
                            termin.Kunden_Nr == 1
                                ? termin.Bestellbemerkung
                                : termin.Firma !== "-" && termin.Firma !== ""
                                    ? termin.Firma
                                    : (termin.Vorname !== null ? termin.Vorname : "") + " " + termin.Nachname,
                        date: termin.Datum,
                        details: `${termin.Bezirk} | Kndnr: ${termin.Kunden_Nr}`,
                        time: termin.Uhrzeit,
                        endtime: termin.Enduhrzeit,
                        duration: termin.duration,
                        color: termin.color,
                        fahrer: termin.fahrer,
                        bezirk: termin.Bezirk,
                        kundennr: termin.Kunden_Nr,
                        anfang: termin.Uhrzeit,
                        ende: termin.Enduhrzeit,
                        strasse: termin.Strasse,
                        hausnr: termin.Hausnummer,
                        plz: termin.PLZ,
                        stadt: termin.Stadt
                    }
                })
                console.log(this.events)
            })
        },
        intervalFormat(interval) {
            return interval.time + " Uhr"
        },
        next() {
            this.$refs.calendar.next()
            this.changeCalendarHeadline()
        },
        prev() {
            this.$refs.calendar.prev()
            this.changeCalendarHeadline()
        },
        setToday() {
            this.start = new Date().toDateString()
            this.changeCalendarHeadline()
        },
        showEvent(e, event) {
            const open = () => {
                this.selectedEvent = event
                this.selectedElement = e.target
                this.x = e.clientX
                this.y = e.clientY
                requestAnimationFrame(() => requestAnimationFrame(() => (this.selectedOpen = true)))
            }

            if (this.selectedOpen) {
                this.selectedOpen = false
                requestAnimationFrame(() => requestAnimationFrame(() => open()))
            } else {
                open()
            }

            e.stopPropagation()
        }
    }
}
</script>

<style lang="stylus" scoped>

    #top-buttons{
        margin-top: 0px;
        margin-bottom: 0px;
    }
    .my-event {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-radius: 2px;
      color: #FFFFFF;
      border: 0.1px solid;
      border-color: #9e9e9e;
      font-size: 12.5px;
      line-height: 1;
      font-weight: bold;
      padding: 0;
      cursor: pointer;
      margin-bottom: 1px;
      left: 4px;
      margin-right: 8px;
      position: relative;

          &.with-time {
             position: absolute;
             right: 4px;
             margin-right: 0;
           }
        }
</style>
